// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ComptabiliteModalSave_checkbox__3NV21"};